import {
  validatePAN,
  validateGST,
  validateMobile,
  validateIFSC,
  validateAccountNumber,
} from "../../utils/validationUtils";

// TODO: these all fileds have KYC fileds
export const ENTITY_INFO_FIELDS = [
  {
    name: "parentName",
    label: "Entity Name",
    type: "text",
    placeholder: "Enter entity name",
    required: false,
  },
  {
    name: "tradeName",
    label: "Trade Name",
    type: "text",
    placeholder: "Enter name as per GST certificate",
    required: false,
  },
  {
    name: "pinCode",
    label: "Pin Code",
    type: "text",
    placeholder: "Enter 6-digit pin code",
    required: true,
    maxLength: 6,
  },
  {
    name: "city",
    label: "City",
    type: "text",
    placeholder: "Auto-filled from pincode",
    readOnly: true,
  },
  {
    name: "State",
    label: "State",
    type: "text",
    placeholder: "Auto-filled from pincode",
    readOnly: true,
  },
  {
    name: "address",
    label: "Address",
    type: "textarea",
    required: true,
    placeholder: "Enter complete address",
    rows: 3,
  },
  {
    name: "natureOfBusiness",
    label: "Nature of Business",
    type: "textarea",
    placeholder: "Brief description of Business",
    required: true,
  },
  {
    name: "entityType",
    label: "Entity Type",
    type: "select",
    required: true,
    options: [
      { value: "", label: "Select entity type" },
      { value: "proprietorship", label: "Proprietorship" },
      { value: "partnership", label: "Partnership" },
      { value: "llp", label: "Limited Liability Partnership (LLP)" },
      { value: "private_limited", label: "Private Limited Company" },
      { value: "public_limited", label: "Public Limited Company" },
      { value: "trust", label: "Trust" },
      { value: "society", label: "Society" },
    ],
  },
  // {
  //   name: "CompanypanNumber",
  //   label: "PAN Number",
  //   type: "text",
  //   placeholder: "e.g. ABCDE1234F",
  //   required: true,
  //   maxLength: 10,
  //   validation: validatePAN,
  // },
];

export const GST_FIELDS = [
  {
    name: "isGSTRegistered",
    label: "GST Registered?",
    type: "select",
    required: true,
    options: [
      { value: "", label: "Select option" },
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
];

export const UTILITY_FIELDS = [
  {
    name: "utilityType",
    label: "Utility Type",
    type: "text",
    placeholder: "e.g. Electricity, Water",
    required: true,
  },
  {
    name: "utilityProviderName",
    label: "Provider Name",
    type: "text",
    placeholder: "Enter provider name",
    required: true,
  },
  {
    name: "utilityAccountNumber",
    label: "Account / Consumer Number",
    type: "text",
    placeholder: "Enter account number",
    required: true,
  },
  {
    name: "utilityAddress",
    label: "Address on Utility Bill",
    type: "textarea",
    placeholder: "Address as on utility bill",
    rows: 2,
    required: true,
  },
];

export const MSME_FIELDS = [
  {
    name: "isMSMERegistered",
    label: "Registered under MSME?",
    type: "select",
    required: true,
    options: [
      { value: "", label: "Select option" },
      { value: "yes", label: "Yes" },
      { value: "no", label: "No" },
    ],
  },
];

export const CONTACT_FIELDS = [
  {
    name: "contactPersonName",
    label: "Contact Person Name",
    type: "text",
    placeholder: "Enter name",
    required: true,
  },
  {
    name: "contactPersonDesignation",
    label: "Designation",
    type: "text",
    placeholder: "Enter designation",
    required: true,
  },
  {
    name: "contactPersonMobile",
    label: "Mobile Number",
    type: "tel",
    placeholder: "10-digit mobile",
    required: true,
    maxLength: 10,
    validation: validateMobile,
  },
];

export const BANK_FIELDS = [
  {
    name: "bankName",
    label: "Bank Name",
    type: "text",
    placeholder: "Enter bank name",
    required: true,
  },
  {
    name: "accountNumber",
    label: "Account Number",
    type: "text",
    placeholder: "Enter account number",
    required: true,
    validation: validateAccountNumber,
  },
  {
    name: "ifscCode",
    label: "IFSC Code",
    type: "text",
    placeholder: "e.g. SBIN0001234",
    required: true,
    maxLength: 11,
    validation: validateIFSC,
  },
  {
    name: "accountType",
    label: "Account Type",
    type: "select",
    require: true,
    options: [
      { value: "", label: "Select account type" },
      { value: "savings", label: "Savings" },
      { value: "current", label: "Current" },
    ],
  },
  {
    name: "branchName",
    label: "Branch Name",
    type: "text",
    placeholder: "Enter branch name",
    required: true,
  },
  {
    name: "beneficiaryName",
    label: "Beneficiary Name",
    type: "text",
    placeholder: "Enter beneficiary name",
    required: true,
  },
];

export const THIRD_PARTY_FIELDS = [
  {
    name: "thirdPartyRelation",
    label: "Relation with Beneficiary",
    type: "text",
    placeholder: "e.g. Parent, Subsidiary",
    required: true,
  },
];

export const DOCS_BANK = [
  {
    key: "doc_bank_proof",
    label: "Bank Document (Passbook / Cancelled Cheque)",
    required: true,
  },
];

export const ALL_FIELDS = [
  ...ENTITY_INFO_FIELDS,
  ...GST_FIELDS,
  ...MSME_FIELDS,
  ...CONTACT_FIELDS,
  ...BANK_FIELDS,
];

// ── Entity-type document requirements ─────────────────────────────────────────
// Each entry: { key: string (used as file state key), label: string }

export const ENTITY_TYPE_DOCUMENTS = {
  // ── Proprietorship ──────────────────────────────────────────────────────────
  proprietorship: [
    {
      key: "doc_aadhar",
      label: "Aadhar Card",
      required: true,
      inputField: {
        name: "doc_aadhar_number",
        placeholder: "Enter Aadhar number",
        maxLength: 12,
      },
    },
    {
      key: "doc_pan",
      label: "PAN Card",
      required: true,
      inputField: {
        name: "doc_pan_number",
        placeholder: "Enter PAN number",
        maxLength: 10,
      },
    },
  ],

  // ── Partnership ─────────────────────────────────────────────────────────────
  partnership: [
    {
      key: "doc_partnershipDeed",
      label: "Partnership Deed",
      required: true,
      inputField: {
        name: "doc_partnershipDeed_ref",
        placeholder: "Enter deed reference / date",
      },
    },
    {
      key: "doc_aadharBoth",
      label: "Aadhar of Both Partners",
      required: true,
      inputField: {
        name: "doc_aadharBoth_numbers",
        placeholder: "Enter Aadhar numbers",
      },
    },
    {
      key: "doc_pan",
      label: "PAN Card",
      required: true,
      inputField: {
        name: "doc_pan_number",
        placeholder: "Enter PAN number",
        maxLength: 10,
      },
    },
  ],

  // ── LLP ─────────────────────────────────────────────────────────────────────
  llp: [
    {
      key: "doc_partnershipDeed",
      label: "Partnership Deed",
      required: true,
      inputField: {
        name: "doc_partnershipDeed_ref",
        placeholder: "Enter deed reference / date",
      },
    },
    {
      key: "doc_aadharBoth",
      label: "Aadhar of Both Partners",
      required: true,
      inputField: {
        name: "doc_aadharBoth_numbers",
        placeholder: "Enter Aadhar numbers ",
      },
    },
    {
      key: "doc_pan",
      label: "PAN Card",
      required: true,
      inputField: {
        name: "doc_pan_number",
        placeholder: "Enter PAN number",
        maxLength: 10,
      },
    },
  ],

  // ── Private Limited ─────────────────────────────────────────────────────────
  private_limited: [
    {
      key: "doc_coi",
      label: "Certificate of Incorporation (COI)",
      required: true,
      inputField: { name: "doc_coi_number", placeholder: "Enter COI number" },
    },
    {
      key: "doc_pan",
      label: "PAN Card",
      required: true,
      inputField: {
        name: "doc_pan_number",
        placeholder: "Enter PAN number",
        maxLength: 10,
      },
    },
    {
      key: "doc_directorPan",
      label: "Director PAN",
      required: true,
      inputField: {
        name: "doc_directorPan_number",
        placeholder: "Enter Director PAN number",
        maxLength: 10,
      },
    },
    {
      key: "doc_directorAadhar",
      label: "Director Aadhar",
      required: true,
      inputField: {
        name: "doc_directorAadhar_number",
        placeholder: "Enter Director Aadhar number",
        maxLength: 12,
      },
    },
  ],

  // ── Public Limited ──────────────────────────────────────────────────────────
  public_limited: [
    {
      key: "doc_coi",
      label: "Certificate of Incorporation (COI)",
      required: true,
      inputField: { name: "doc_coi_number", placeholder: "Enter COI number" },
    },
    {
      key: "doc_pan",
      label: "PAN Card",
      required: true,
      inputField: {
        name: "doc_pan_number",
        placeholder: "Enter PAN number",
        maxLength: 10,
      },
    },
    {
      key: "doc_directorPan",
      label: "Director PAN",
      required: false,
      inputField: {
        name: "doc_directorPan_number",
        placeholder: "Enter Director PAN number",
        maxLength: 10,
      },
    },
    {
      key: "doc_directorAadhar",
      label: "Director Aadhar",
      required: false,
      inputField: {
        name: "doc_directorAadhar_number",
        placeholder: "Enter Director Aadhar number",
        maxLength: 12,
      },
    },
  ],

  // ── Trust ───────────────────────────────────────────────────────────────────
  trust: [
    {
      key: "doc_trustDeed",
      label: "Trust Deed",
      required: true,
      inputField: {
        name: "doc_trustDeed_ref",
        placeholder: "Enter trust deed reference / date",
      },
    },
    {
      key: "doc_panTrust",
      label: "PAN of Trust",
      required: true,
      inputField: {
        name: "doc_panTrust_number",
        placeholder: "Enter Trust PAN number",
        maxLength: 10,
      },
    },
    {
      key: "doc_aadharTrustee",
      label: "Aadhar of Trustee",
      required: true,
      inputField: {
        name: "doc_aadharTrustee_number",
        placeholder: "Enter Trustee Aadhar number",
        maxLength: 12,
      },
    },
    {
      key: "doc_panTrustee",
      label: "PAN of Trustee",
      required: false,
      inputField: {
        name: "doc_panTrustee_number",
        placeholder: "Enter Trustee PAN number",
        maxLength: 10,
      },
    },
  ],

  // ── Society ─────────────────────────────────────────────────────────────────
  society: [
    {
      key: "doc_pan",
      label: "PAN Card",
      required: true,
      inputField: {
        name: "doc_pan_number",
        placeholder: "Enter PAN number",
        maxLength: 10,
      },
    },
    {
      key: "doc_aadhar",
      label: "Aadhar Card",
      required: true,
      inputField: {
        name: "doc_aadhar_number",
        placeholder: "Enter Aadhar number",
        maxLength: 12,
      },
    },
  ],
};

// Re-export validateGST so it's accessible from this module
export { validateGST };

// ── Maps internal doc keys → API DocumentType values ──────────────────────────
export const DOC_KEY_TO_API_TYPE = {
  // Entity-type docs
  doc_aadhar: "AadharCardPath",
  doc_pan: "PANCardPath",
  doc_partnershipDeed: "PartnershipDeedPath",
  doc_aadharBoth: "AadharOfBothPartnersPath",
  doc_coi: "CertificateOfIncorporationPath",
  doc_directorPan: "DirectorPANPath",
  doc_directorAadhar: "AadharCardPath",
  doc_trustDeed: "PartnershipDeedPath",
  doc_panTrust: "PANCardPath",
  doc_aadharTrustee: "AadharCardPath",
  doc_panTrustee: "PANCardPath",

  // Conditional docs
  doc_gst_certificate: "GSTCertificatePath",
  doc_utility_bill: "UtilityBillDocumentPath",
  doc_msme_certificate: "MSMECertificatePath",

  // Bank docs
  doc_bank_proof: "PassbookOrCancelledChequePath",

  // GST file (per entry)
  gst_file: "GSTCertificatePath",

  // MSME file
  msme_file: "MSMECertificatePath",

  // Utility bill file
  utility_file: "UtilityBillDocumentPath",

  // Third party / signed form
  third_party_file: "UploadSignedFormPath",
};
